import { LoanLimit } from "./loanLimit";

export default LoanLimit;